import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { isFunction } from 'lodash';
import PIIVerifyNowPopup from './popup';

const PIIVerifyNowModal = ({ isShow, action, actionClose }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <PIIVerifyNowPopup
      isOpen={isShow}
      buttonLabel1={t('button_later')}
      onClose={handleOnClose}
      buttonLabel2={t('button_verify_now')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default PIIVerifyNowModal;
